import React, { useState, useCallback } from 'react';
import { Grid, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const readPersistedExpanded = (persistKey, defaultExpanded) => {
  if (!persistKey) return defaultExpanded;
  try {
    const v = localStorage.getItem(persistKey);
    if (v === null) return defaultExpanded;
    return v === 'true';
  } catch {
    return defaultExpanded;
  }
};

const TicketAccordion = ({ title, children, sx, xs, defaultExpanded = false, persistKey }) => {
  const [expanded, setExpanded] = useState(() =>
    persistKey ? readPersistedExpanded(persistKey, defaultExpanded) : defaultExpanded
  );

  const handleChange = useCallback(
    (_, nextExpanded) => {
      setExpanded(nextExpanded);
      if (persistKey) {
        try {
          localStorage.setItem(persistKey, String(nextExpanded));
        } catch {}
      }
    },
    [persistKey]
  );

  return (
    <Grid item xs={xs} sx={{ padding: 0, ...sx }}>
      <Accordion
        expanded={persistKey ? expanded : undefined}
        defaultExpanded={persistKey ? undefined : defaultExpanded}
        onChange={persistKey ? handleChange : undefined}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid sx={{ width: '100%' }}>
            {children}
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default TicketAccordion;
